import { render, staticRenderFns } from "./Managed-companies-menu.vue?vue&type=template&id=e65f94a4"
import script from "./Managed-companies-menu.vue?vue&type=script&lang=js"
export * from "./Managed-companies-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports